import { Grid } from '@material-ui/core';
import React from 'react';
import BaseButton from 'src/common/components/base-button';
import { normalizeLength } from 'src/common/helpers/string-helper';
import IAlertCategory from 'src/common/interfaces/states/IAlertCategory';
import { styles } from './category-button-styles';

interface AlertMenuCategoryButtonProps {
  category: IAlertCategory;
  clickHandler: (alertGroupId: string) => void;
}

const AlertMenuCategoryButton = ({
  category,
  clickHandler,
}: AlertMenuCategoryButtonProps): JSX.Element => {
  const classes = styles({ selected: category.selected });

  return (
    <Grid container justifyContent='center'>
      <Grid item className={classes.categoryButtonContainerItem}>
        <BaseButton
          fullWidth
          buttonType={category.selected ? 'white' : 'alternate'}
          classes={{ root: classes.categoryButtonRoot }}
          onClick={(): void => clickHandler(category.alertGroupId)}
          data-testid='alert-button-category'
        >
          {normalizeLength(category.name, 42)}
        </BaseButton>
      </Grid>
    </Grid>
  );
};

export default AlertMenuCategoryButton;
